class SiteChart {
    constructor() {
        const _ = this;

        ScrollTrigger.create({
            trigger: '#chiffres-graph',
            // markers: true,
            onEnter: () => {
                $('#chiffres-graph [id^="calque"]').stop().css({ opacity: 0 }).each(function (i) {
                    $(this).delay(i * 250).animate({ opacity: 1 }, 500);
                });
            },
            onEnterBack: () => {
                $('#chiffres-graph [id^="calque"]').stop().css({ opacity: 0 }).each(function (i) {
                    $(this).delay(i * 250).animate({ opacity: 1 }, 500);
                });
            },
        });

        $('canvas.chartjs').each(function () {
            let chart = null;

            ScrollTrigger.create({
                trigger: this,
                // markers: true,
                onEnter: () => {
                    if (chart) {
                        chart.reset();
                        chart.update();
                    } else {
                        chart = _.chart($(this));
                    }
                },
                onEnterBack: () => {
                    if (chart) {
                        chart.reset();
                        chart.update();
                    } else {
                        chart = _.chart($(this));
                    }
                },
            });
        });
    }
    chart(elem = null) {
        if (!elem)
            return;

        let datasets = [],
            config = {
                plugins: [/*ChartDeferred,*/ ChartjsPluginStacked100.default],
                options: {
                    events: [],
                    animations: {},
                    animation: {
                        // duration: 2000,
                        onProgress: animation => {
                            animation.chart.data.datasets.forEach(data => {
                                if (!data.elem || !document.querySelector(data.elem))
                                    return;
                                const percentage = animation.currentStep / animation.numSteps;

                                switch (elem.data('type')) {
                                    case 1:
                                        document.querySelector(data.elem).innerText = Math.round(data.data[1] * percentage) + ' %';
                                        break;

                                    case 2:
                                    case 3:
                                        data.data.forEach((v, i) => document.querySelector(data.elem[i]).innerText = Math.round(v * percentage) + ' %');
                                        break;
                                }
                            });
                        }
                    },
                    plugins: {
                        legend: {
                            display: false
                        },
                        tooltip: {
                            enabled: false
                        },
                        // deferred: {
                        //     xOffset: 100,   // defer until 150px of the canvas width are inside the viewport
                        //     yOffset: '100%', // defer until 50% of the canvas height are inside the viewport
                        //     delay: 300      // delay of 500 ms after the canvas is considered inside the viewport
                        // },
                        stacked100: {
                            enable: false
                        }
                    }
                },
            };

        switch (elem.data('type')) {
            case 1:
                datasets = elem.data('datasets');
                datasets.map(x => $(x.elem).text('0 %'));
                config.data = {
                    datasets: [
                        {
                            type: "doughnut",
                            data: [100 - datasets[0].value, datasets[0].value],
                            cutout: '40%',
                            borderWidth: 0,
                            backgroundColor: ['#FF5F1740', '#FF5F17'],
                            elem: datasets[0].elem
                        },
                        {
                            type: "pie",
                            data: [100 - datasets[1].value, datasets[1].value],
                            radius: "128%",
                            borderWidth: 0,
                            backgroundColor: context => {
                                if (!context.chart.chartArea)
                                    return;

                                const gradient1 = context.chart.ctx.createLinearGradient(0, 50, 50, 0);
                                gradient1.addColorStop(0, '#2955E540');
                                gradient1.addColorStop(1, '#00BD6040');

                                const gradient2 = context.chart.ctx.createLinearGradient(0, 50, 50, 0);
                                gradient2.addColorStop(0, '#2955E5');
                                gradient2.addColorStop(1, '#00BD60');

                                return [gradient1, gradient2];
                            },
                            elem: datasets[1].elem
                        }
                    ]
                };
                config.options.animations = {
                    startAngle: {
                        from: Math.PI * 1.5
                    },
                    endAngle: {
                        from: Math.PI * 1.5
                    }
                }
                break;

            case 2:
                datasets = elem.data('datasets');
                datasets.map(x => $(x.elem).text('0 %'));
                config.data = {
                    datasets: [
                        {
                            type: "doughnut",
                            data: datasets.map(x => x.value),
                            cutout: '65%',
                            borderWidth: 0,
                            backgroundColor: ['#0A48BC', '#01BB63', '#1F6FC4', '#05A639', '#FF5F17'],
                            elem: datasets.map(x => x.elem)
                        }
                    ]
                };
                break;

            case 3:
                datasets = elem.data('datasets');
                datasets.map(x => $(x.elem).text('0 %'));
                config.data = {
                    labels: [''],
                    datasets: []
                };
                config.type = "bar";
                config.options.indexAxis = 'y';
                config.options.scales = {
                    x: {
                        display: false,
                        stacked: true
                    },
                    y: {
                        display: false,
                        stacked: true
                    }
                };
                config.options.plugins.stacked100 = { enable: true };
                const backgroundColor = ['#ff5f17', '#0a48bc', '#01ba64', '#1f6fc4'];
                datasets.forEach((x, i) => {
                    config.data.datasets.push({
                        barPercentage: 1.5,
                        data: [x.value],
                        backgroundColor: [backgroundColor[i]],
                        elem: [x.elem],
                    });
                });
                break;

            default:
                return false;
        }

        return new Chart(elem[0].getContext('2d'), config);
    }
}